import React from 'react';

import NavBar from '../components/NavBar';


function PropertiesRMs() {
    return (
        <>  
            <div className='h1'>
                <h1>Resident Manager Assignments (Properties_RMs)</h1>
            </div>
            
            <div className='parent'>
                <div className='child'>
                    <label>
                        Assign RM: 
                    </label>
                    <select name="property_id" id="dropdown">
                        <option value="property_id">Property ID*</option>
                        <option value="000001">000001</option>
                        <option value="000002">000002</option>
                        <option value="000003">000003</option>
                    </select>
                    <select name="rm_id" id="dropdown">
                        <option value="rm_id">Resident Manager ID*</option>
                        <option value="000001">000001</option>
                        <option value="000002">000002</option>
                        <option value="000003">000003</option>
                    </select>
                    <input type="submit" value="Submit" />
                    <div className='center-note'>
                        <p>* indicates a required field.</p>
                    </div>
                </div>
                <br></br>
                <div className='child'>
                    <label>
                        Search by RM: 
                    </label>
                    <input type="text" placeholder="RM ID" />
                    <input type="submit" value="Submit" />
                </div>
                <br></br>
                <div className='child'>
                    <label>
                        Search by Property: 
                    </label>
                    <input type="text" placeholder="Property ID" />
                    <input type="submit" value="Submit" />
                </div>
                
            </div>
            <div className='center-paragraph'>
                <p>* Deleting a property will remove all resident manager assignments associated with that property, but will not delete the resident manager.</p>
            </div>
            <table id="customers" className='center-table'>
                <tr>
                    <th>Property ID</th>
                    <th>Street Address</th>
                    <th>Resident Manager ID</th>
                    <th>First Name</th>
                    <th>Last Name</th>
                    <th></th>
                </tr>
                <tr>
                    <td>000001</td>
                    <td>123 Main St.</td>
                    <td>000001</td>
                    <td>Alice</td>
                    <td>Apple</td>
                    <td><button>Remove Assignment (Delete)</button></td>
                </tr>
                <tr>
                    <td>000002</td>
                    <td>455 16th St.</td>
                    <td>000002</td>
                    <td>David</td>
                    <td>Danes</td>
                    <td><button>Remove Assignment (Delete)</button></td>
                </tr>
            </table>

            <br></br>
            
            <div>
                <NavBar />
            </div>
        </>
    );
}

export default PropertiesRMs;